import React from 'react';
import styled from 'styled-components';
import { Card } from 'ui-components';

import { Main, Header } from '../hocs';
import CARDS from '../data/cards';
import { Info, AppBar, Footer, SectionDivider } from '../components';

const CardWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  max-width: 1600px;
  flex-direction: row;
  padding-bottom: 20px;
  justify-content: space-between;
`;

const InfoWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color: #fafafa;
  justify-content: space-evenly;
`;

const WideCard = styled(Card)`
  width: 370px !important;

  /* Normalize top logo area so all card headers render consistently. */
  & > div:first-child {
    height: 72px !important;
  }

  & > div:first-child img {
    width: 220px !important;
    height: 52px !important;
    object-fit: contain !important;
  }

  /* Puzzle Paint asset has extra transparent padding; scale visually to match others. */
  & > div:first-child img[alt='Puzzle Paint'] {
    transform: scale(1.78);
    transform-origin: center;
  }

  /* Card link rows are 39px. A two-line title overflows that box and paints
     over the previous row and the game tags. Let that row grow, and place
     the tags on the next line so the full label stays readable. */
  & div:has(> div > a .card-link-multiline) {
    height: auto;
    min-height: 39px;
  }

  & div:has(> div > a .card-link-multiline) > div:first-child {
    flex-wrap: wrap;
    align-items: flex-end;
    row-gap: 6px;
  }

  & div:has(> div > a .card-link-multiline) > div:first-child > a {
    flex: 1 0 100%;
    align-items: flex-start;
    line-height: 20px;
  }

  & .card-link-multiline {
    display: block;
    line-height: 20px;
    white-space: nowrap;
  }

  & div:has(> div > a .card-link-multiline) > div:first-child > a + div {
    margin-left: auto;
  }
`;

function RenderCard(card, index) {
  return (
    <WideCard
      key={index}
      title={card.title}
      image={card.image}
      links={card.links}
      socials={card.socials}
    />
  );
}

function Home() {
  const Cards = () => CARDS.map((card, index) => RenderCard(card, index));

  return (
    <Main>
      <Header>
        <AppBar />
      </Header>
      <CardWrapper>
        <Cards />
      </CardWrapper>
      <SectionDivider />
      <InfoWrapper>
        <Info />
      </InfoWrapper>
      <Footer />
    </Main>
  );
}

export default Home;
